module.exports = ".center-vertical {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  position: fixed;\n  background-color: rgba(100, 100, 100, 0.3); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/loading-spinner/loading-spinner.component.scss
// module id = 633
// module chunks = 0